// extracted by mini-css-extract-plugin
export var actions = "_7x-8";
export var arrow = "_7x-5";
export var card = "_7x-0";
export var cardWrapper = "_7x-9";
export var fieldName = "_7x-3";
export var newValue = "_7x-6";
export var oldValue = "_7x-4";
export var orangeGlowFade = "_7x-c";
export var productSection = "_7x-1";
export var scrollToBottom = "_7x-b";
export var scrollToBottomAnchor = "_7x-a";
export var scrollToBottomIcon = "_7x-d";
export var showAllButton = "_7x-7";
export var table = "_7x-2";